import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '@/components/base/SEO';
import Breadcrumb from '@/components/base/Breadcrumb';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { testimonials, categories } from '@/mocks/data';

const faqs = [
  {
    question: '51在线吃瓜网是做什么的？',
    answer: '51在线吃瓜网是一个专注于网络热点事件追踪的娱乐资讯平台，每日更新网红黑料、吃瓜大赛、最新爆料视频等内容，为吃瓜群众提供最新鲜、最劲爆的娱乐资讯。',
  },
  {
    question: '网站内容真实吗？',
    answer: '我们所有内容均来自公开渠道和可靠信源，并会标注消息来源。对于独家爆料，我们会尽可能核实后再发布。同时我们欢迎用户监督和纠错，发现不实内容可联系我们删除或更正。',
  },
  {
    question: '如何投稿爆料？',
    answer: '您可以通过页脚"投稿爆料"按钮进入投稿页面，也可以通过邮箱 contact@51chigua.com 发送爆料线索。经采纳的独家线索，爆料人可获得现金奖励。',
  },
  {
    question: '网站多久更新一次？',
    answer: '51在线吃瓜网实行7×24小时实时更新机制，热点事件发生后会在第一时间发布相关资讯。每日凌晨0点和中午12点各进行一次全站内容刷新，确保您看到最新最全的吃瓜内容。',
  },
  {
    question: '如何订阅每日热瓜？',
    answer: '您可以在页脚输入邮箱地址订阅我们的每日热瓜简报，每天早上8点准时推送前一天全网最值得关注的吃瓜事件。此外，关注我们的微博、抖音和公众号也能第一时间获取更新通知。',
  },
];

export default function AboutPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51在线吃瓜网',
    url: window.location.origin + ((window as any).__BASE_PATH__ || ''),
    logo: `${window.location.origin}/vite.svg`,
    description: '全网最专业的吃瓜导航，每日更新网红黑料、最新爆料视频',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-5151',
      contactType: 'customer service',
      areaServed: 'CN',
      availableLanguage: 'Chinese',
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京市',
      addressRegion: '朝阳区',
      streetAddress: '望京SOHO T1-1208',
      addressCountry: 'CN',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 51在线吃瓜网',
    description: '了解51在线吃瓜网的品牌故事、发展历程、联系方式及常见问题解答',
    url: window.location.href,
    isPartOf: {
      '@type': 'WebSite',
      name: '51在线吃瓜网',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <SEO
        title="关于我们 - 51在线吃瓜网 | 品牌介绍、口碑评价、联系方式"
        description="了解51在线吃瓜网的品牌故事、发展历程、用户评价及联系方式。我们专注于全网吃瓜资讯追踪，每日更新网红黑料、最新爆料视频。"
        keywords="51在线吃瓜网,关于我们,品牌介绍,联系方式,吃瓜资讯,网红黑料"
        canonicalUrl="/about"
      />
      <Navbar />
      <main className="pt-16">
        {/* Hero */}
        <section className="relative bg-foreground-950 py-16 md:py-28">
          <div className="absolute inset-0 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=dramatic%20dark%20abstract%20background%20with%20subtle%20warm%20amber%20and%20red%20accents%20cinematic%20lighting%20modern%20editorial%20design%20atmosphere%20elegant%20mood%20texture&width=1800&height=500&seq=about-bg-01&orientation=landscape"
              alt=""
              className="w-full h-full object-cover opacity-30"
              aria-hidden="true"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/80" />
          </div>
          <div className="relative z-10 max-w-[1440px] mx-auto px-4 md:px-6">
            <Breadcrumb items={breadcrumbItems} />
            <div className="mt-6 md:mt-10 text-center">
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-4">
                关于51在线吃瓜
              </h1>
              <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto font-label">
                全网最专业的吃瓜导航，每日更新网红黑料、吃瓜大赛、最新爆料视频，实时追踪网络热点事件，吃瓜群众在线观看不迷路。
              </p>
            </div>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
              <div>
                <span className="tag-pill bg-primary-50 text-primary-700 font-label mb-4 inline-block">
                  品牌故事
                </span>
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-6">
                  让每一口瓜都吃得明明白白
                </h2>
                <div className="space-y-4 text-foreground-700 text-sm md:text-base leading-relaxed font-body">
                  <p>
                    51在线吃瓜网成立于2025年，是国内领先的吃瓜资讯聚合平台。我们的名字来源于"51"（我要）和"吃瓜"（围观热点事件），寓意"我要吃瓜"——我们要让每位用户都能第一时间吃到最新鲜、最劲爆的瓜。
                  </p>
                  <p>
                    从最初的个人博客发展到如今拥有数百万月活用户的综合资讯平台，我们始终坚持"真实、快速、深度"的内容原则。我们的编辑团队24小时轮班值守，确保热点事件发生后能在第一时间为用户提供详实报道。
                  </p>
                  <p>
                    目前，51在线吃瓜网覆盖网红黑料、明星八卦、综艺互撕、吃瓜大赛、最新爆料视频等8大频道，累计发布爆料文章超过2000篇，全网阅读量突破10亿次。
                  </p>
                </div>

                <div className="grid grid-cols-3 gap-4 mt-8">
                  <div className="text-center">
                    <p className="font-heading text-2xl md:text-3xl font-black text-primary-500">10亿+</p>
                    <p className="text-foreground-500 text-xs font-label mt-1">累计阅读量</p>
                  </div>
                  <div className="text-center">
                    <p className="font-heading text-2xl md:text-3xl font-black text-primary-500">2000+</p>
                    <p className="text-foreground-500 text-xs font-label mt-1">爆料文章</p>
                  </div>
                  <div className="text-center">
                    <p className="font-heading text-2xl md:text-3xl font-black text-primary-500">8</p>
                    <p className="text-foreground-500 text-xs font-label mt-1">内容频道</p>
                  </div>
                </div>
              </div>

              <div className="relative">
                <div className="aspect-[4/5] rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=dramatic%20editorial%20photo%20of%20Chinese%20young%20people%20gathered%20around%20smartphones%20watching%20content%20excited%20expressions%20warm%20indoor%20lighting%20modern%20coffee%20shop%20setting%20candid%20moment%20cinematic%20composition&width=700&height=875&seq=about-story-01&orientation=portrait"
                    alt="51在线吃瓜用户场景"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-4 -left-4 bg-white rounded-xl p-4 shadow-lg border border-background-200/70 hidden md:block">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                      <i className="ri-fire-line text-white text-sm" />
                    </div>
                    <div>
                      <p className="font-label font-bold text-foreground-900 text-sm">实时更新</p>
                      <p className="text-foreground-400 text-xs font-label">7×24小时不间断</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Categories Overview */}
        <section className="py-16 md:py-24 bg-white">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <span className="tag-pill bg-secondary-50 text-secondary-700 font-label mb-4 inline-block">
                内容矩阵
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
                八大频道，全网覆盖
              </h2>
              <p className="text-foreground-500 text-sm md:text-base font-label">
                从网红黑料到明星八卦，从综艺互撕到吃瓜大赛，你想看的都在这里
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 rounded-xl p-5 md:p-6 card-hover border border-background-200/70 hover:bg-primary-500 hover:border-primary-500 transition-all duration-300"
                >
                  <div className="w-10 h-10 rounded-xl bg-background-100 flex items-center justify-center mb-3 group-hover:bg-white/20 transition-colors">
                    <i className={`${cat.icon} text-xl text-primary-500 group-hover:text-white transition-colors`} />
                  </div>
                  <h3 className="font-heading font-bold text-foreground-900 group-hover:text-white transition-colors text-sm mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-foreground-500 text-xs group-hover:text-white/70 transition-colors font-label">
                    {cat.description}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <span className="tag-pill bg-accent-50 text-accent-700 font-label mb-4 inline-block">
                用户口碑
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
                来自真实用户的评价
              </h2>
              <p className="text-foreground-500 text-sm md:text-base font-label">
                数百万吃瓜群众的选择与信赖
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {testimonials.map((t, i) => (
                <div key={i} className="bg-white rounded-xl p-6 md:p-8 border border-background-200/70">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-background-100 flex items-center justify-center">
                      <i className={`${t.avatar} text-foreground-500 text-lg`} />
                    </div>
                    <div>
                      <p className="font-label font-medium text-foreground-900 text-sm">{t.name}</p>
                      <div className="flex items-center gap-0.5">
                        {[...Array(5)].map((_, j) => (
                          <span key={j} className="w-3 h-3 flex items-center justify-center">
                            <i className="ri-star-fill text-accent-500 text-xs" />
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed font-body">
                    &ldquo;{t.content}&rdquo;
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-16 md:py-24 bg-white">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
              <div>
                <span className="tag-pill bg-primary-50 text-primary-700 font-label mb-4 inline-block">
                  联系我们
                </span>
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-6">
                  有任何问题或爆料线索？
                </h2>
                <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-8 font-body">
                  我们欢迎所有用户的反馈和建议。如果您有独家爆料线索，欢迎随时联系我们。一经采纳，爆料人可获得现金奖励。
                </p>

                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-500" />
                    </div>
                    <div>
                      <p className="font-label font-medium text-foreground-900 text-sm mb-1">邮箱地址</p>
                      <p className="text-foreground-500 text-sm font-label">contact@51chigua.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-primary-500" />
                    </div>
                    <div>
                      <p className="font-label font-medium text-foreground-900 text-sm mb-1">客服热线</p>
                      <p className="text-foreground-500 text-sm font-label">400-888-5151</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-primary-500" />
                    </div>
                    <div>
                      <p className="font-label font-medium text-foreground-900 text-sm mb-1">商务合作地址</p>
                      <p className="text-foreground-500 text-sm font-label">北京市朝阳区望京SOHO T1-1208</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-primary-500" />
                    </div>
                    <div>
                      <p className="font-label font-medium text-foreground-900 text-sm mb-1">服务时间</p>
                      <p className="text-foreground-500 text-sm font-label">7×24小时全天在线</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
                <h3 className="font-heading font-bold text-foreground-900 text-lg mb-4">快速留言</h3>
                <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
                  <div>
                    <label className="block text-foreground-600 text-sm font-label mb-1.5">您的称呼</label>
                    <input
                      type="text"
                      name="name"
                      className="w-full bg-white border border-background-200/70 rounded-lg px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors font-label"
                      placeholder="请输入您的称呼"
                    />
                  </div>
                  <div>
                    <label className="block text-foreground-600 text-sm font-label mb-1.5">邮箱</label>
                    <input
                      type="email"
                      name="email"
                      className="w-full bg-white border border-background-200/70 rounded-lg px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors font-label"
                      placeholder="请输入邮箱地址"
                    />
                  </div>
                  <div>
                    <label className="block text-foreground-600 text-sm font-label mb-1.5">留言内容</label>
                    <textarea
                      name="message"
                      rows={4}
                      maxLength={500}
                      className="w-full bg-white border border-background-200/70 rounded-lg px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors font-label resize-none"
                      placeholder="请输入您的留言内容（最多500字）"
                    />
                  </div>
                  <input type="text" name="company_alt" className="honeypot-field" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  <button type="submit" className="btn-primary w-full">提交留言</button>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <span className="tag-pill bg-secondary-50 text-secondary-700 font-label mb-4 inline-block">
                常见问题
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
                FAQ
              </h2>
              <p className="text-foreground-500 text-sm md:text-base font-label">
                关于51在线吃瓜的常见问题解答
              </p>
            </div>

            <div className="max-w-2xl mx-auto space-y-3">
              {faqs.map((faq, i) => (
                <div key={i} className="bg-white rounded-xl border border-background-200/70 overflow-hidden">
                  <button
                    className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    aria-expanded={openFaq === i}
                  >
                    <span className="font-label font-medium text-foreground-900 text-sm pr-4">{faq.question}</span>
                    <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform ${openFaq === i ? 'rotate-180' : ''}`}>
                      <i className="ri-arrow-down-s-line text-foreground-400" />
                    </span>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${openFaq === i ? 'max-h-96' : 'max-h-0'}`}
                  >
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-foreground-600 text-sm leading-relaxed font-body">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}